import React from "react";
import { SEO } from "../components/SEO";
import { BIZ } from "../lib/constants";

export default function Terms() {
    return (
        <>
            <SEO
                title="Terms of Service"
                description="Terms governing your use of Liquor Studio's website and services."
                path="/terms"
            />

            <section
                style={{ paddingTop: 160, paddingBottom: 64, borderBottom: "1px solid var(--ls-border)" }}
            >
                <div className="ls-container max-w-3xl">
                    <span className="eyebrow">Legal</span>
                    <h1
                        className="font-display mt-5 text-white"
                        style={{
                            fontSize: "clamp(40px, 6vw, 64px)",
                            fontWeight: 500,
                            lineHeight: 1.05,
                            letterSpacing: "-0.02em",
                        }}
                    >
                        Terms of Service
                    </h1>
                    <p className="mt-4 text-sm" style={{ color: "var(--ls-text-muted)" }}>
                        Last updated: February 1, 2026
                    </p>
                </div>
            </section>

            <section className="section-y" data-testid="terms-content">
                <div
                    className="ls-container max-w-3xl"
                    style={{ color: "var(--ls-text-secondary)", fontSize: 16, lineHeight: 1.8 }}
                >
                    <p>
                        Welcome to Liquor Studio. By accessing or using this site, you agree to be
                        bound by the terms below.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Age requirement
                    </h2>
                    <p className="mt-4">
                        You must be{" "}
                        <strong className="text-white">21 years of age or older</strong> to use this
                        site. By entering you confirm you are of legal drinking age. Missouri state
                        law (RSMo § 311.310) prohibits the sale of intoxicating liquor to persons
                        under 21. We may refuse service to anyone, at any time, for any lawful reason.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        No shipping of alcohol
                    </h2>
                    <p className="mt-4">
                        Liquor Studio does not ship alcoholic beverages.
                        All alcohol orders placed through our online catalog at{" "}
                        <a href={BIZ.shopUrl} target="_blank" rel="noopener noreferrer" className="link-underline text-white">
                            shop.liquor.studio
                        </a>{" "}
                        are fulfilled via{" "}
                        <strong className="text-white">in-store pickup or local pickup</strong> only.
                        ID is required at pickup, and the person picking up must be the same person
                        who placed the order.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Site content
                    </h2>
                    <p className="mt-4">
                        All content on this site — text, images, logos, brand marks — is the
                        property of Liquor Studio or used with permission. You may not copy,
                        reproduce, or redistribute it without our written consent.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Pricing & availability
                    </h2>
                    <p className="mt-4">
                        Product pricing and availability on{" "}
                        <a href={BIZ.shopUrl} target="_blank" rel="noopener noreferrer" className="link-underline text-white">
                            shop.liquor.studio
                        </a>{" "}
                        are subject to change without notice. We do our best to keep listings
                        accurate, but errors happen. If we cannot fulfill your order at the listed
                        price, we will contact you before charging.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Limitation of liability
                    </h2>
                    <p className="mt-4">
                        This site is provided "as is" without warranties of any kind. To the maximum
                        extent permitted by law, Liquor Studio is not liable for any indirect,
                        incidental, or consequential damages arising from your use of this site.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Governing law
                    </h2>
                    <p className="mt-4">
                        These terms are governed by the laws of the State of Missouri, United States.
                    </p>

                    <h2 className="font-display text-white mt-12" style={{ fontSize: 26, fontWeight: 500 }}>
                        Contact
                    </h2>
                    <p className="mt-4">
                        Questions? Email{" "}
                        <a href={`mailto:${BIZ.email}`} className="link-underline text-white">
                            {BIZ.email}
                        </a>.
                    </p>
                </div>
            </section>
        </>
    );
}
